module.exports = __webpack_public_path__ + "img/excellentCancel.38ffdedb.png";